import { useQuery } from '@tanstack/react-query';
import api from '../../services/api';
import { Meta } from '../Advert/FindAll';

export interface TypeOfImportRequest {
    email?: string;
    id?: number;
    startDate?: string;
    endDate?: string;
    type?: 'PRODUCT_GLOBAL' | 'PRODUCT';
    page: number;
    perPage: number;
}

export interface CreatedByUser {
    email: string;
    id: number;
}

export interface ImportReport {
    created_by_user_id: number;
    id: number;
    response: ResponseErrorCharge;
    error: any;
    status: string;
    created_at: string;
    finished_at: string;
    type: string;
    origin: string;
    action: string;
    createdByUser: CreatedByUser;
}

export interface ResponseErrorCharge {
    errorNum: number;
    errors: any;
    ignoredNum: number;
    importedNum: number;
    message?: string;
}

interface ImportRequestResponse {
    data: Array<ImportReport>;
    meta: Meta;
}

export const useImportRequest = (paramsImportRequest: TypeOfImportRequest) => {
    const queryFn = async () => {
        const { data } = await api.get<ImportRequestResponse>(
            'import-request',
            {
                params: paramsImportRequest,
            },
        );

        return {
            data: data.data,
            meta: data.meta,
        };
    };

    return useQuery({
        queryFn,
        queryKey: ['IMPORT_REQUEST', paramsImportRequest],
    });
};
